export default __webpack_public_path__ + "80f07073e922d2bc65df682e8ca28113.woff2";